import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingPanelService } from '../../../../services';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { BlockUIModule } from 'primeng/blockui';

@Component({
  selector: 'custom-loading-panel',
  standalone: true,
  imports: [CommonModule, DialogModule, ProgressSpinnerModule, BlockUIModule],
  templateUrl: './custom-loading-panel.component.html',
  styleUrl: './custom-loading-panel.component.scss'
})
export class CustomLoadingPanelComponent implements OnInit, OnDestroy {

  displayDialog = false;

  private _showSubscription !: Subscription;
  private _hideSubscription !: Subscription;
  showSimple: boolean = false;
  translations: any = {};

  constructor(private _lps: LoadingPanelService, private _t: TranslateService) {
    this._showSubscription = this._lps.showSource$.subscribe(showSimple => {
      this.show(showSimple);
    });
    this._hideSubscription = this._lps.hideSource$.subscribe(key => {
      this.hide();
    });
  }

  async ngOnInit() {
    this.translations = await firstValueFrom(forkJoin({
      cargando: this._t.get('msg.cargando'),
    }));
  }

  ngOnDestroy(): void {
    if (this._showSubscription) {
      this._showSubscription.unsubscribe();
    }
    if (this._hideSubscription) {
      this._hideSubscription.unsubscribe();
    }
  }

  show(showSimple: boolean = false) {
    this.showSimple = showSimple;
    this.displayDialog = true;
  }

  hide() {
    this.displayDialog = false;
  }
}
